/**
 * InlineTextView view.
 *
 * @subscribes copy-edit-button-enabled
 * @subscribes copy-edit-button-disabled
 *
 */

var ShapewaysView = require('./ShapewaysView');
var $ = require('./../../sw-jquery/sw-jquery');
var _ = require('underscore');
var sw = require('js/lib/sw');

var PRE_PARSE_BB_CODE = 'bbcode';

window.CKEDITOR_BASEPATH = '/rrstatic/javascript/vendor/ckeditor/';

var RichTextView = ShapewaysView.extend({

  swAttr: {
    height: 'data-sw-rich-text-area-height',
    preParse: 'data-sw-rich-text-area-pre-parse'
  },

  initialize: function() {

    var self = this;

    require([
      './../../sw-jquery/vendor/sw-ck-adapter',
      'js/vendor/ckeditor/ckeditor'
    ], function(ckplugin) {
      ckplugin($);
      self.initCK();
      self.repaint();
    });
  },

  initCK: function() {
    var editor = null;
    var self = this;

    /**
     * Add static tag cache busting to ckeditor and its plugins
     */
    var ckEditorPluginPath = 'javascript/vendor/ckeditor/plugins/',
      ckEditorPluginPathInfo = _.find(sw.data.assets.jsAssets , function(asset) {
        return asset.assetPath === ckEditorPluginPath;
      });
    window.CKEDITOR.timestamp = ckEditorPluginPathInfo.assetHash;
    
    /**
     * check to make sure the ckEditor event is for this view instance
     * @param e
     * @return {*|boolean}
     */
    function eventIsForThisInstance(e) {
      return editor && editor.id && (editor.id === e.editor.id);
    }

    window.CKEDITOR.on('instanceReady', function(e){
      if (eventIsForThisInstance(e)) {
        var $container = $(editor.container.$);
        $container.attr('class', $container.attr('class') + ' ' + self.$el.attr('class'));
        $container.attr('title', self.$el.attr('placeholder'));

        editor.on('focus', function() {
          $container.addClass('cke_focus');
        });

        var throttledUpdate = _.throttle(_.bind(self.updateEditorElement, self), 350);
        editor.on('change', throttledUpdate);

        editor.on('blur', function() {
          $container.removeClass('cke_focus');
        });

        // Make sure all links generated by ckeditor have rel="nofollow" attribute
        editor.dataProcessor.htmlFilter.addRules({
          elements: {
            a: function (element) {
              element.attributes.rel = 'nofollow';
            }
          }
        });
      }

    });

    var height = self.$el.attr(self.swAttr.height) || 160;
    this.editor = editor = window.CKEDITOR.replace(this.$el[0], {
      height: height,
      extraAllowedContent: 'img[!src,alt,title,width,height,style](*){*}',
      linkShowAdvancedTab: false,
      linkShowTargetTab: false,
      toolbarGroups: [],
      toolbar: [
        {
          name: 'basicstyles',
          items: [
            'Bold', 'Italic'
          ]
        },
        {
          name: 'paragraph',
          groups: [
            'list',
            'indent',
            'blocks',
            'align',
            'bidi'
          ],
          items: [
            'NumberedList',
            'BulletedList',
            '-',
            'Blockquote',
            'CreateDiv',
            '-',
            'JustifyLeft',
            'JustifyCenter',
            'JustifyRight',
            'JustifyBlock',
            '-',
            'BidiLtr',
            'BidiRtl'
          ]
        },
        '-',
        {
          name: 'links',
          items: [
            'Link', 'Unlink'
          ]
        },
        '-',
        {
          name: 'styles',
          items: [
            'FontSize'
          ]
        },
        '-',
        {
          name: 'document',
          items: [
            'Sourcedialog'
          ]
        }
      ],
      removeButtons: '',
      removeDialogTabs: '',
      extraPlugins: 'sourcedialog,blockquote,justify,font,bbcode'
    });

    // Trigger events so view can compose with other auto handlers and view builders
    editor.on('change', function triggerOnEl(e) {
      if (eventIsForThisInstance(e)) {
        self.$el.val(e.editor.getData());
        self.$el.trigger('change').trigger('keyup');
      }
    });

    /**
     * Convert HTML to BBCode on init if necessary
     * @see http://docs.ckeditor.com/#!/api/CKEDITOR.editor-event-setData
     */
    editor.once('setData', function setData(e) {
      if (eventIsForThisInstance(e) && (self.$el.attr(self.swAttr.preParse) === PRE_PARSE_BB_CODE)) {
        e.data.dataValue = editor.dataProcessor.toDataFormat(e.data.dataValue);
        editor.once('dataReady', function() {
          editor.fire('change');
        });
      }
    });

    // add css to iframe. Must get the cache-busting hash of the resource from sw.data.assets
    var screenCss = 'stylesheets/screen.css',
        screenCssInfo = _.find(sw.data.assets.cssAssets, function(asset) {
          return asset.assetPath === screenCss;
        });
    if (!_.isUndefined(screenCssInfo)) {
      var screenCssHash = screenCssInfo.assetHash;
      editor.addContentsCss(sw.data.baseUrl + '/rrstatic/' + screenCss + '?tag=' + screenCssHash);
    }
    window.CKEDITOR.addCss('.cke_contents_ltr blockquote { padding-left: 0px; padding-right: 0px; } ');

  },

  updateEditorElement: function() {
    var editor = this.editor;

    if (editor) {
      editor.updateElement();
    }
  },

  removeCK: function() {
    this.editor.destroy();
    this.editor = null;
  }

});

module.exports = RichTextView;
